<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}
.img1 {
  width: 100%;
  height: 100%;
  border: 0;
  margin-top: -1vh;
}
.footer {
  height: 40vw;
  background: #ffffff;
  img {
    width: 20vw;
  }
}
.footer-button {
  background: #333;
  width: 70vw;
  height: 13vw;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}
</style>

<template>
  <div class="container">
    <div style="background: #ffffff">
      <img class="img1" src="../../assets/ad/nb-1.png" />
      <img class="img1" src="../../assets/ad/nb-2.png" />
      <img class="img1" src="../../assets/ad/nb-3.png" />
      <img class="img1" src="../../assets/ad/nb-4.png" />
      <img class="img1" src="../../assets/ad/nb-5.png" />
      <img class="img1" src="../../assets/ad/nb-6.png" />
      <img class="img1" src="../../assets/ad/nb-7.png" />
    </div>
    <div class="footer">
      <div class="footer-button" @click="handleClick">
        <img src="../../assets/ad/buy.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NBLock",
  data() {
    return {};
  },
  methods: {
    handleClick() {
      window.location.href =
        "https://item.taobao.com/item.htm?spm=a230r.7195193.1997079397.10.7eb0b4013zKrTC&id=629779760656&abbucket=3";
    },
  },
};
</script>
